import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LodgeStateService } from '../../services/lodge-state.service';

@Component({
  selector: 'app-site-footer',
  standalone: true,
  imports: [CommonModule,RouterLink],
  templateUrl: './site-footer.component.html',
  styleUrls: ['./site-footer.component.scss'],
})
export class SiteFooterComponent {

  year = new Date().getFullYear();

  lodgeDetails$ = this.lodgeState.lodgeDetails$;

  defaultLodge = {
    listing_id: '',
    name: 'Safarizine',
    short_desc: 'A calm lodge base for wildlife stays, family breaks, and guided nature escapes.',
    brief_info: '',
    info_email: '',
  };

  constructor(private lodgeState: LodgeStateService) {}

  quickLinks = [
    { title: 'About', url: '/about' },
    { title: 'Amenities', url: '/amenities' },
    { title: 'Experience', url: '/experience' },
    { title: 'Offers', url: '/offers' },
    { title: 'Booking Info', url: '/booking-info' },
  ];

  policyLinks = [
    { title: 'Backend Guide', url: '/admin-guide' },
    { title: 'Privacy Policy', url: '/privacy-policy' },
    { title: 'Terms & Conditions', url: '/tnc' },
  ];
}
